let discountedTotal = 0;

document.addEventListener("DOMContentLoaded", function () {

  /* -------------------------------------------------------
      FIXED BUNDLE PRICING (your base price)
  ------------------------------------------------------- */
  const qty = 3;
    const pricePerItem = 20;
    const discountPerItem = 6.67;

    discountedTotal = (pricePerItem - discountPerItem) * qty; 



  /* -------------------------------------------------------
      1. SCENT SWATCHES
  ------------------------------------------------------- */
    const swatches = document.querySelectorAll('.holiday-swatch');

    swatches.forEach(swatch => {
      swatch.addEventListener('click', function () {
        const holidayRow = this.closest('.holiday-row');
        const mainImage = holidayRow.querySelector('.holiday-main-image');
        const selectedTitle = holidayRow.querySelector('.selected-scent-title');

        const newImage = this.dataset.image;
        const newTitle = this.dataset.title;
        const isSoldOut = this.classList.contains('product-false');

        // Always update image
        if (newImage) mainImage.src = newImage;

        // Remove active from siblings
        holidayRow.querySelectorAll('.holiday-swatch').forEach(s => s.classList.remove('active'));

        // Mark active
        this.classList.add('active');

        // Show title with sold out label
        if (selectedTitle) {
          selectedTitle.textContent = isSoldOut
            ? `${newTitle} – Sold Out`
            : newTitle;
             selectedTitle.classList.toggle('sold-out', isSoldOut);
        }

        // Re-check ATC state
        updateATCState();
      });
    });


  document.querySelectorAll('.holiday-row').forEach(row => {
    const activeSwatch = row.querySelector('.holiday-swatch.active');
    const selectedTitle = row.querySelector('.selected-scent-title');
    if (activeSwatch && selectedTitle) {
      selectedTitle.textContent = activeSwatch.dataset.title;
    }
  });



  /* -------------------------------------------------------
      2. PLUS / MINUS FUNCTIONALITY FOR ADDONS
  ------------------------------------------------------- */
  const qtyWrappers = document.querySelectorAll(".addon-qtty");

  qtyWrappers.forEach(wrapper => {
    const minusBtn = wrapper.querySelector(".minus");
    const plusBtn = wrapper.querySelector(".plus");
    const input = wrapper.querySelector(".quantity__input");

    plusBtn.addEventListener("click", function () {
      let value = parseInt(input.value) || 0;
      input.value = value + 1;
      updateTotalWithAddons();
    });

    minusBtn.addEventListener("click", function () {
      let value = parseInt(input.value) || 0;

      if (value > 1) {
        input.value = value - 1;
      } else if (value === 1) {
        input.value = 0;

        const addonWrapper = wrapper.closest(".holiday-addon-wrapper");
        const addonBtn = addonWrapper.querySelector(".holiday-addon-atc");

        wrapper.style.display = "none";
        addonBtn.classList.remove("active");
        addonWrapper.classList.remove("active-addon");
        addonBtn.style.display = "block";
      }

      updateTotalWithAddons();
    });
  });



  /* -------------------------------------------------------
      3. ADDON SELECT BUTTON ("Add")
  ------------------------------------------------------- */
  const addonButtons = document.querySelectorAll(".holiday-addon-atc");

  addonButtons.forEach(btn => {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".holiday-addon-wrapper");
      const qtyBox = wrapper.querySelector(".addon-qtty");
      const input = qtyBox.querySelector(".quantity__input");

      wrapper.classList.add("active-addon");
      btn.classList.add("active");
      btn.style.display = "none";

      qtyBox.style.display = "flex";
      input.value = 1;

      updateTotalWithAddons();
    });
  });



  /* -------------------------------------------------------
      4. MAIN ATC — ADD TO CART
  ------------------------------------------------------- */
  const mainATC = document.querySelector(".holiday-atc");

  mainATC.addEventListener("click", function () {
    mainATC.classList.add("loading");

    const itemsToAdd = [];

    // scents
  document.querySelectorAll(".holiday-swatch.active").forEach(swatch => {
    if (swatch.classList.contains('product-false')) return;

    const variantId = swatch.dataset.variantId;
    const title = swatch.dataset.title;

    if (variantId) {
      itemsToAdd.push({
        id: variantId,
        quantity: 1,
        properties: { "Selected Scent": title }
      });
    }
  });


    // addons
    document.querySelectorAll(".holiday-addon-atc.active").forEach(addonBtn => {
      const wrapper = addonBtn.closest(".holiday-addon-wrapper");
      const qty = parseInt(wrapper.querySelector(".quantity__input").value) || 0;

      if (addonBtn.dataset.variantId && qty > 0) {
        itemsToAdd.push({
          id: addonBtn.dataset.variantId,
          quantity: qty
        });
      }
    });

    if (itemsToAdd.length === 0) {
      alert("Please select at least one scent or addon.");
      mainATC.classList.remove("loading");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: itemsToAdd })
    })
      .then(res => res.json())
      .then(() => (window.location.href = "/checkout"))
      .catch(() => alert("Some items may be out of stock."))
      .finally(() => mainATC.classList.remove("loading"));
  });



  /* -------------------------------------------------------
      5. STICKY BAR SHOW/HIDE
  ------------------------------------------------------- */
  const stickyCart = document.querySelector('.holiday-sticky-atc');
    const desktopstickyCart = document.querySelector('.product__sticky-bar');
  
  const mainSection = document.querySelector('.product__new-section');
  const subscription = document.querySelector('.product__new-section .holiday-atc');

  function isInView(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function isPast(el) {
    return el.getBoundingClientRect().top < 0;
  }

  window.addEventListener('scroll', () => {
    if (isInView(mainSection)) {
      if (!isPast(subscription)) {
        stickyCart.classList.add('hidden');
         desktopstickyCart.classList.add('hidden');
        document.body.classList.remove('stickycart-bar-show');
      } else {
        stickyCart.classList.remove('hidden');
        desktopstickyCart.classList.remove('hidden');
        document.body.classList.add('stickycart-bar-show');
      }
    } else {
      stickyCart.classList.remove('hidden');
      desktopstickyCart.classList.remove('hidden');
      document.body.classList.add('stickycart-bar-show');
    }
  });



  /* -------------------------------------------------------
      6. MOBILE STICKY ATC
  ------------------------------------------------------- */
  const stickyAtcButton = document.querySelector('.holiday-sticky-atc .holiday-atc-btn');
    const stickyAtcButtondesk = document.querySelector('.holiday-sticky-atc-desk .holiday-atc-btn');
  const mainAtcButton = document.querySelector('.holiday-atc');

  if (stickyAtcButton && mainAtcButton) {
    stickyAtcButton.addEventListener('click', function () {
      stickyAtcButton.classList.add('loading');
      mainAtcButton.click();
    });

    new MutationObserver(() => {
      if (mainAtcButton.classList.contains('loading')) {
        stickyAtcButton.classList.add('loading');
      } else {
        stickyAtcButton.classList.remove('loading');
      }
    }).observe(mainAtcButton, { attributes: true, attributeFilter: ['class'] });
  }
    if (stickyAtcButtondesk && mainAtcButton) {
    stickyAtcButtondesk.addEventListener('click', function () {
      stickyAtcButtondesk.classList.add('loading');
      mainAtcButton.click();
    });

    new MutationObserver(() => {
      if (mainAtcButton.classList.contains('loading')) {
        stickyAtcButtondesk.classList.add('loading');
      } else {
        stickyAtcButtondesk.classList.remove('loading');
      }
    }).observe(mainAtcButton, { attributes: true, attributeFilter: ['class'] });
  }



  /* -------------------------------------------------------
      7. PRICE CALCULATION (simple)
  ------------------------------------------------------- */
      function updateTotalWithAddons() {
        let addonsTotal = 0;

        document.querySelectorAll('.holiday-addon-wrapper').forEach(wrapper => {
          const btn = wrapper.querySelector('.holiday-addon-atc');
          const qtyInput = wrapper.querySelector('.quantity__input');

          // convert from Shopify cents → dollars
          const price = (Number(btn.dataset.price) || 0) / 100;
          const qty = Number(qtyInput.value) || 0;

          addonsTotal += price * qty;
        });

        const grandTotal = Number(discountedTotal) + Number(addonsTotal);

        console.log({
          discountedTotal,
          addonsTotal,
          grandTotal
        });

        document.querySelector('.holiday-price').textContent = `$${grandTotal.toFixed(2)}`;
        document.querySelector('.discounted-price').textContent = `$${grandTotal.toFixed(2)}`;
        document.querySelector('.holiday-sticky-atc .holiday-price').textContent = `$${grandTotal.toFixed(2)}`;
        document.querySelector('.holiday-sticky-atc-desk .holiday-price').textContent = `$${grandTotal.toFixed(2)}`;

      }
      function updateBasePrice() {
        document.querySelector('.holiday-price').textContent = `$${discountedTotal.toFixed(2)}`;
        document.querySelector('.discounted-price').textContent = `$${discountedTotal.toFixed(2)}`;
        document.querySelector('.holiday-sticky-atc .holiday-price').textContent = `$${discountedTotal.toFixed(2)}`;
        document.querySelector('.holiday-sticky-atc-desk .holiday-price').textContent = `$${discountedTotal.toFixed(2)}`;
      }



    // run once on load
    updateBasePrice();
    updateTotalWithAddons();

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.holiday-row').forEach(row => {
    const activeSwatch = row.querySelector('.holiday-swatch.active');
    if (!activeSwatch) return;

    const image = activeSwatch.dataset.image;
    const title = activeSwatch.dataset.title;

    const imgEl = row.querySelector('.holiday-main-image');
    const titleEl = row.querySelector('.selected-scent-title');

    if (imgEl && image) {
      imgEl.src = image;
    }

    if (titleEl && title) {
      titleEl.textContent = title;
    }
  });
});

function updateATCState() {
  const mainATC = document.querySelector('.holiday-atc');
  const stickyATC = document.querySelector('.holiday-sticky-atc-btn');

  let hasSoldOut = false;

  document.querySelectorAll('.holiday-row').forEach(row => {
    const active = row.querySelector('.holiday-swatch.active');
    if (active && active.classList.contains('product-false')) {
      hasSoldOut = true;
    }
  });

  if (hasSoldOut) {
    mainATC.classList.add('disabled');
    mainATC.setAttribute('disabled', true);
    mainATC.textContent = 'Sold Out';

    if (stickyATC) {
      stickyATC.classList.add('disabled');
      stickyATC.setAttribute('disabled', true);
    }
  } else {
    mainATC.classList.remove('disabled');
    mainATC.removeAttribute('disabled');
    mainATC.innerHTML = `Buy Now <span class="holiday-price"></span>`;

    if (stickyATC) {
      stickyATC.classList.remove('disabled');
      stickyATC.removeAttribute('disabled');
    }
  }
}
